import { BookSection } from '@Models';

export class BookSectionView {
  item: BookSection;
  id: string;
  index: number;
  position: string;
  name: string;

  constructor(data: BookSectionViewParams) {
    this.item = data.item;
    this.id = data.id;
    this.index = data.index;
    this.position = data.position;
    this.name = data.name;
  }
}

export type BookSectionViewParams = {
  item: BookSection;
  id: string;
  index: number;
  position: string;
  name: string;
};
